import { Component, Input } from '@angular/core';

/**
 * @group Basic Toolkit
 * @component Truncate Popover
 *
 * @export
 * @class LsqTruncateComponent
 */

@Component({
    selector: 'lsq-truncate',
    template: `
        <span *ngIf="value.length <= maxLength">{{ value }}</span>
        <span *ngIf="value.length > maxLength" [popover]="value">
            {{ value.length > maxLength ? (value | slice: 0:maxLength) + '...' : value }}
        </span>
    `
})
export class LsqTruncateComponent {
    @Input() public value: string;
    @Input() public maxLength = 20;
}
